import { PURCHASE_EVENT, SIGNATURE_EVENT } from "@/core/data";
import pushPurchaseEvent from "@/core/utils/eventsToExpose/pushPurchaseEvent";
import pushSignatureEvent from "@/core/utils/eventsToExpose/pushSignatureEvent";

export type EventCallbackData = {
  definitionName?: string;
  domain: string;
};

export type EventCallback = (eventData: EventCallbackData) => void;

const eventToCallbackMatrix: Record<string, EventCallback> = {
  [PURCHASE_EVENT]: pushPurchaseEvent,
  [SIGNATURE_EVENT]: pushSignatureEvent,
};

const getEventToExposeCallback = (
  eventName: string
): EventCallback | undefined => eventToCallbackMatrix[eventName];

export default getEventToExposeCallback;
